import {React, useCallback} from 'react'
import './pages.css'
import * as AiIcons from 'react-icons/ai'
import * as RiIcons from 'react-icons/ri'
import * as BsIcons from 'react-icons/bs'
import * as FaIcons from 'react-icons/fa'
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
const Home = () => {

    const particlesInit = useCallback(async (engine) => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(engine);
    }, []);

    const particlesLoaded = useCallback(async (container) => {
        await console.log(container);
    }, []);

    return (
        <div style={{display: 'flex', flexDirection: 'column',justifyContent: 'center', alignItems: 'center', height: '90vh', backgroundColor: '#040c33', zIndex: 10 }}>
            <div class="fade-in-text1">
                <h1 className='header'>Altaaf Ackbar</h1>

            </div>
            <div class="fade-in-text2">
        
                <div className='icons'>
                <a href='https://github.com/altaafackbar?tab=repositories' target="_blank">
                    <div className='icon'>
                        <BsIcons.BsGithub size ={70} />
                    </div>
                </a>
                <a href='https://www.linkedin.com/in/altaafackbar/' target="_blank">
                    <div className='icon'>
                        <BsIcons.BsLinkedin size ={70} />
                    </div>
                </a>
                </div>

                
                <p className='sub'>Software Developer and Front-end Developer</p>

            </div>

            <div class="fade-in-text2">
                <p className='text'>I am a recent graduate from the University of Alberta with over two years of hands on software development and fullstack development experience.
I am a self-motivated team player with great communication skills who enjoys creating highly responsive and user friendly web experiences, and delivering accurate products that go above and beyond requirements.</p>
                <a href='https://drive.google.com/file/d/1aLoIW6d92cTYQi9sNfpAVTBa0LQ5mMHu/view?usp=sharing' target="_blank">
                    <button type="button" class='bouncy'>
                        <h3>
                            View Resume
                        </h3>
                    </button>
                </a>


                
             </div>

             
            
        <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                background: {
                    color: {
                        value: "#040c33",
                    },
                },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        push: {
                            quantity: 4,
                        },
                        repulse: {
                            distance: 100,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: "#ffffff",
                    },
                    links: {
                        color: "#714d97",
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    collisions: {
                        enable: false,
                    },
                    move: {
                        directions: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 2,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
        </div>
    )
}

export default Home